var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"menu-container"},[_c('b-nav',[_c('b-nav-item-dropdown',{attrs:{"text":"Perfil","right":""}},[_c('b-dropdown-item',{on:{"click":_vm.logout}},[_vm._v("Cerrar Sesión")])],1)],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }